module.exports = __webpack_public_path__ + "img/new.0bd4b554.svg";